import React from "react";

import { QuantityButtonsWidgetCompact } from "@src/QuantityButtonsView/variants/QuantityButtonsWidgetCompact";
import { QuantityButtonsWidgetImage } from "@src/QuantityButtonsView/variants/QuantityButtonsWidgetImage";

import { useQuantityButtonsContext } from "./context/QuantityButtonsContext";
import { QuantityButtonsWidget1 } from "./variants/QuantityButtonsWidget1";
import { QuantityButtonsWidget4 } from "./variants/QuantityButtonsWidget4";
import { QuantityButtonsWidgetClassic } from "./variants/QuantityButtonsWidgetClassic";

export const QuantityButtonsFactory = () => {
  const { widget } = useQuantityButtonsContext();

  const variant = widget.variant;
  switch (variant) {
    case "quantityButtonsWidget1":
      return <QuantityButtonsWidget1 />;
    case "quantityButtonsWidget4":
      return <QuantityButtonsWidget4 />;
    case "quantityButtonsWidgetClassic":
      return <QuantityButtonsWidgetClassic />;
    case "quantityButtonsWidgetCompact":
      return <QuantityButtonsWidgetCompact />;
    case "quantityButtonsWidgetImage":
      return <QuantityButtonsWidgetImage />;
    default:
      console.error(`Unrecognized quantity buttons widget}`);
  }
};
